import { set, isOver } from "../../js/lib/util";
import inViewport from "../../js/lib/in-viewport";

const breakpoint = 768;

export default (el: HTMLElement) => {
  let video = (el.querySelector(".js-video") as HTMLVideoElement) || false;

  if (video && isOver(breakpoint)) {
    let src = video.getAttribute("data-src");

    if (!src) {
      return;
    }

    inViewport(
      video,
      {
        offset: 300,
      },
      () => {
        video.setAttribute("src", src);
        set(el, "is-loaded");
      }
    );
  }
};
